import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const payrollReasonCodeService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/PayrollReasonCode`, { headers });
  },

  getAllActive: async () => {
    return await axios.get(`${domain}/api/PayrollReasonCode/active`, { headers });
  },

  getById: async (id) => {
    return await axios.get(`${domain}/api/PayrollReasonCode/${id}`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/PayrollReasonCode`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/PayrollReasonCode/${id}`, payload, { headers });
  },
};

export default payrollReasonCodeService;